<template>
  <form @submit.prevent="update" id="my-account-password">
    <div class="alert -success" v-if="finished">
      <p>Senha alterada com sucesso!</p>
    </div>

    <div class="alert -danger" v-if="errors.unrecognized">
      <p>Ocorreu um erro desconhecido ao alterar sua senha, por favor tente novamente.</p>
    </div>

    <div class="form-group" :class="{ '-has-error': errors.form.old_password.length > 0 }">
      <label for="oldPassword" class="label">Senha Atual</label>
      <input
        type="password"
        id="oldPassword"
        name="oldPassword"
        class="form-control"
        v-model="form.old_password"
      >
      <p class="description" v-if="errors.form.old_password.length > 0">{{ errors.form.old_password[0] }}</p>
    </div>

    <div class="form-group" :class="{ '-has-error': errors.form.new_password.length > 0 }">
      <label for="newPassword" class="label">Nova Senha</label>
      <input
        type="password"
        id="newPassword"
        name="newPassword"
        class="form-control"
        v-model="form.new_password"
      >
      <p class="description" v-if="errors.form.new_password.length > 0">{{ errors.form.new_password[0] }}</p>
    </div>

    <div class="form-group">
      <label for="newPasswordConfirmation" class="label">Confirmar Nova Senha</label>
      <input
        type="password"
        id="newPasswordConfirmation"
        name="newPasswordConfirmation"
        class="form-control"
        v-model="form.new_password_confirmation"
      >
    </div>

    <div class="flex">
      <button class="btn btn-primary ml-auto" type="submit">Salvar</button>
    </div>

    <loader v-if="loading"/>
  </form>
</template>

<script>
import checkErrorIsUnrecognizedResponse from '@/support/helpers/checkErrorIsUnrecognizedResponse';
import Loader from '@/support/components/Loader.vue';

export default {
  name: 'Password',

  data() {
    return {
      loading: false,
      finished: false,
      form: {
        old_password: '',
        new_password: '',
        new_password_confirmation: '',
      },
      errors: {
        unrecognized: false,
        form: {
          old_password: [],
          new_password: [],
        },
      },
    };
  },

  methods: {
    /**
     * Update the password.
     *
     * @returns {Promise<void>}
     */
    async update() {
      try {
        this.finished = false;
        this.loading = true;
        this.resetErrors();

        await this.$store.dispatch('auth/updatePassword', this.form);

        this.finished = true;
      } catch (err) {
        if (checkErrorIsUnrecognizedResponse(err, [422])) {
          this.errors.unrecognized = true;
          return;
        }

        const { data, status } = err.response;

        if (status === 422) {
          this.errors.form.old_password = data.errors.old_password || [];
          this.errors.form.new_password = data.errors.new_password || [];
        }
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the errors page.
     */
    resetErrors() {
      this.errors.form.old_password = [];
      this.errors.form.new_password = [];
      this.errors.unrecognized = false;
    },
  },

  components: {
    Loader,
  },
};
</script>

<style lang="scss" scoped>

</style>
